var map = {
	"./bot-avatar.png": 203,
	"./image-amyrobson.png": 204,
	"./image-amyrobson.webp": 340,
	"./image-juliusomo.png": 728,
	"./image-juliusomo.webp": 56,
	"./image-maxblagun.png": 603,
	"./image-maxblagun.webp": 963,
	"./image-ramsesmiron.png": 595,
	"./image-ramsesmiron.webp": 439
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 509;